import Body from "./body";
import Heading from "./heading";
import Banner from "./banner";
import ContactBar, { ContactBarItem } from "./contact_bar";
import HeroRoot from "./hero";
import Paragraph from "./paragraph";
import VideoBanner from "./video";
import Container from "./container";
import Glow from "./glow";
import Purchase from "./purchase";

const HeroUI = Object.assign(HeroRoot, {
  Glow,
  Banner,
  VideoBanner,
  Body,
  Heading,
  Paragraph,
  Purchase,
  ContactBar,
  ContactBarItem,
  Container,
});

export default HeroUI;
